import { Pipe, PipeTransform } from '@angular/core';
import { sortingInfo } from '../models/filter.model';


@Pipe({
  name: 'searchResultFilter'
})

export class FilterPipe implements PipeTransform {
    transform(items: any[], selectedBrands: any[], selectedTypes: any[], selectedCategories: any[], selectedSeriese: any[], filterValue: any, sortingInfo?:sortingInfo, sortingTrigger?:number): any[] {



        var filterResult: any[] = [];
        var filterBrandResult: any[] = [];
        var filterTypeResult: any[] = [];
        var filterCatResult: any[] = [];
        var filterSeResult: any[] = [];
        var inputFilterResult: any[] = [];

        // console.log(sortingInfo);

        if(!items) return [];



        if(!this.checkingArr(selectedBrands) && !this.checkingArr(selectedTypes) && !this.checkingArr(selectedCategories) && !this.checkingArr(selectedSeriese) && !filterValue){
            if(sortingInfo){
                if(sortingInfo.comparedProperty === '' && sortingInfo.sortingOrder === ''){
                    return items;
                }else{
                    return this.sorting(sortingInfo, items);
                }
            }else{
                return items;
            }

        }


        // Brand Filter
        if(this.checkingArr(selectedBrands)){
            for(let singleSearchText of selectedBrands){
                let newResult =  items.filter( it => {
                    if(it.lr_stk_brand == ""){
                        it.lr_stk_brand = "UNKNOWN";
                    }
                    if(it.lr_stk_brand.toLowerCase() === singleSearchText.toLowerCase()){
                        return it;
                    }
                });  
                if(typeof filterBrandResult !== 'undefined' && filterBrandResult.length > 0 ){
                    filterBrandResult = filterBrandResult.concat(newResult)
                }else if( newResult.length > 0){
                    filterBrandResult = newResult;
                }
            }
        }

        // Type Filter
        if(this.checkingArr(selectedTypes)){
            for(let singleSearchText of selectedTypes){
                let newResult =  items.filter( it => {
                    if(it.lr_primary_cat == ""){
                        it.lr_primary_cat = "UNKNOWN";
                    }
                    if(it.lr_primary_cat.toLowerCase() === singleSearchText.toLowerCase() ){
                        return it;
                    }
                    // return it.lr_primary_cat.toLowerCase().includes(singleSearchText.toLowerCase());
                });
    
                if(typeof filterTypeResult !== 'undefined' && filterTypeResult.length > 0 ){
                    filterTypeResult = filterTypeResult.concat(newResult)
                }else if( newResult.length > 0){
                    filterTypeResult = newResult;
                }
            }
        }

        //Category Filter
        if(this.checkingArr(selectedCategories)){
            for(let singleSearchText of selectedCategories){
                let newResult =  items.filter( it => {
                    if(it.lr_secondary_cat == ""){
                        it.lr_secondary_cat = "UNKNOWN";
                    }
                    if(it.lr_secondary_cat.toLowerCase() === singleSearchText.toLowerCase() ){
                        return it;
                    }
                });
    
                if(typeof filterCatResult !== 'undefined' && filterCatResult.length > 0 ){
                    filterCatResult = filterCatResult.concat(newResult)
                }else if( newResult.length > 0){
                    filterCatResult = newResult;
                }
            }
        }

        //Series Filter
        if(this.checkingArr(selectedSeriese)){
            for(let singleSearchText of selectedSeriese){
                let newResult =  items.filter( it => {
                    if(it.lr_tertiary_cat == ""){
                        it.lr_tertiary_cat = "UNKNOWN";
                    }
                    if(it.lr_tertiary_cat.toLowerCase() === singleSearchText.toLowerCase() ){
                        return it;
                    }
                });
    
                if(typeof filterSeResult !== 'undefined' && filterSeResult.length > 0 ){
                    filterSeResult = filterSeResult.concat(newResult)
                }else if( newResult.length > 0){
                    filterSeResult = newResult;
                }
            }
        }

        // combine the array
        var combine_array = [filterBrandResult, filterTypeResult,filterCatResult,filterSeResult];

        // filter out the array is not empty
        var pick_result = combine_array.filter(function( v ) {
            return v.length > 0;
        });

        // concat the result from array filter
        filterResult = pick_result.map(function(a) {
            return filterResult.concat(a);
        });

        if(typeof filterResult == "undefined"){
            console.log(filterResult);
        }else if(filterResult.length === 1){
            // if there is only one non-empty array returned from filterBrandResult, filterTypeResult,filterCatResult and filterSeResult
            filterResult =  filterResult[0];
        }else if (filterResult.length === 2){
            // if there are only two non-empty arrays returned
            filterResult = this.intersection_destructive(filterResult[0], filterResult[1]); 
        }else if(filterResult.length === 3){
            // if there are only three non-empty arrays returned
            let A = this.intersection_destructive(filterResult[0], filterResult[1]); 
            let B = filterResult[2]
            filterResult = this.intersection_destructive(A, B);
        }else if(filterResult.length === 4){
            // if there are only three non-empty arrays returned
            let A = this.intersection_destructive(filterResult[0], filterResult[1]); 
            let B = this.intersection_destructive(filterResult[2], filterResult[3]);
            filterResult = this.intersection_destructive(A, B);
        }

        // console.log(filterResult.slice());
        // console.log("------------------------------------");
        //checking the input value 
        if(filterValue){
            inputFilterResult =  items.filter( it => {
                if( it.lr_stock_code.toLowerCase().includes(filterValue.toLowerCase()) ){
                    return it;
                }else if( it.lr_stk_brand.toLowerCase().includes(filterValue.toLowerCase()) ){
                    return it;
                }else if( it.lr_stk_description.toLowerCase().includes(filterValue.toLowerCase()) ){
                    return it;
                }
            });
            if(!this.checkingArr(selectedBrands) && !this.checkingArr(selectedTypes) && !this.checkingArr(selectedCategories) && !this.checkingArr(selectedSeriese)) {
                filterResult = inputFilterResult;
            }else{
                filterResult = this.intersection_destructive(filterResult, inputFilterResult);
            }
        }

        //-----------------------------Adding sorting here-----------------------------------
        this.sorting(sortingInfo,filterResult);
        //-----------------------------Adding sorting here-----------------------------------

        if(filterResult.length > 0){
            return filterResult;
        }else{
            return [];
        }

    }
    intersection_destructive(a: any[], b: any[]):any{
        if( typeof a !== "undefined" &&  typeof b !== "undefined"){
            let result: any[] = [];
            a.forEach(elementInA => {
                b.forEach(elementInB => {
                    if(elementInA.lr_stock_code == elementInB.lr_stock_code){
                        result.push(elementInA);
                    }else{
                        // console.log("not matched result");
                    }
                });
            });
            if(result.length > 0){
                return result;
            }else{
                return [];
            }
        }

    }

    checkingArr(array: any[] | undefined):boolean{
        if(typeof array != "undefined" && array != null
        ){
            if(array.length != null && array.length > 0){
                return true;
            }
            return false;
        }else{
            return false;
        }
    }
    sorting(sortingInfo:sortingInfo | undefined, filterResult: any[]){
        if(sortingInfo){
            // Sort by price
            if(sortingInfo.comparedProperty === 'price'){
                if(sortingInfo.sortingOrder === 'descending'){
                    filterResult.sort((a: any, b: any) => a.lr_stk_price - b.lr_stk_price);
                }else if(sortingInfo.sortingOrder === 'ascending'){
                    filterResult.sort((a: any, b: any) => b.lr_stk_price - a.lr_stk_price);
                }
            }
            //sort by description
            if(sortingInfo.comparedProperty === 'description'){
                if(sortingInfo.sortingOrder === 'descending'){
                    filterResult.sort(function(a, b){
                        var x = a.lr_stk_description.toLowerCase().trim();
                        var y = b.lr_stk_description.toLowerCase().trim();
                        if (x < y) {return -1;}
                        if (x > y) {return 1;}
                        return 0;
                    });
                }else if(sortingInfo.sortingOrder === 'ascending'){
                    filterResult.sort(function(a, b){
                        var x = a.lr_stk_description.toLowerCase().trim();
                        var y = b.lr_stk_description.toLowerCase().trim();
                        if (x < y) {return -1;}
                        if (x > y) {return 1;}
                        return 0;
                    });
                    filterResult.reverse();
                }
            }
            //sort by soh
            if(sortingInfo.comparedProperty === 'soh'){
                if(sortingInfo.sortingOrder === 'descending'){
                    console.log('sort by des');
                    filterResult.sort((a: any, b: any) => a.lr_avail_qty - b.lr_avail_qty);
                }else if(sortingInfo.sortingOrder === 'ascending'){
                    filterResult.sort((a: any, b: any) => b.lr_avail_qty - a.lr_avail_qty);
                }
            }       
        }

        return filterResult;
    }

}




